import React, { ReactNode } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import styled from 'styled-components';

import { BreadcrumbsSeparator } from '@/public/icons';

type TBreadCrumbProps = {
  homeElement: ReactNode;
  separator: ReactNode;
  containerClasses?: string;
  listClasses?: string;
  activeClasses?: string;
  capitalizeLinks?: boolean;
};

const Breadcrumb = ({ homeElement }: TBreadCrumbProps) => {
  const paths = usePathname();
  const pathNames = paths.split('/').filter((path) => path);

  return (
    <Wrapper>
      <List itemScope itemType="https://schema.org/BreadcrumbList">
        {pathNames.map((link, index) => {
          const href = `/${pathNames.slice(0, index + 1).join('/')}`;
          const itemClasses = paths === href ? 'active' : 'noactive';
          const itemLink = link
            ? link[0].toUpperCase() + link.slice(1, link.length)
            : link;
          return (
            <React.Fragment key={index}>
              <Item
                className={itemClasses}
                itemProp="itemListElement"
                itemScope
                itemType="https://schema.org/ListItem"
              >
                <Link
                  href={(index === 0 ? homeElement : href) as string}
                  itemProp="item"
                  prefetch={false}
                >
                  <span itemProp="name">{itemLink}</span>
                </Link>
                <meta itemProp="position" content={(index + 1).toString()} />
              </Item>
              {index === 0 && pathNames.length > 0 && <BreadcrumbsSeparator />}
            </React.Fragment>
          );
        })}
      </List>
    </Wrapper>
  );
};

export default Breadcrumb;

const Wrapper = styled.div`
  margin-bottom: 24px;
`;

const List = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  padding: 0;
  gap: 4px;
`;

const Item = styled.li`
  font-family: var(--font-roboto);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  & a {
    text-decoration: none;
  }
  &.home-element {
  }

  &.noactive {
    a {
      color: #999;
    }
  }

  &.active {
    a {
      color: #206fed;
    }
  }
`;
